import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getInsuranceCoverageRequirementStatus } from "./getInsuranceCoverageRequirementStatus";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { RequirementContextType } from "../../../../types";

export const getInsuranceCoveragePayeeRequirementStatus = (
  requirement: IRequirementResponse,
  insuranceCoverage: InsuranceCoverageMonitor | undefined
) => {
  // For payee view, use the same logic as general status
  return getInsuranceCoverageRequirementStatus(
    requirement,
    insuranceCoverage,
    RequirementContextType.Payee
  );
};
